module.exports = __webpack_public_path__ + "Evan Au Yang-eea7eb22.png";